<template>
  <div class="urgency_plan">
    <enfold-uc>
      <template slot="up">
        <div class="titd"><span class="tit">{{$t('schedule.playPlan')}}</span></div>
      </template>
      <template slot="center">
        <template v-if="this.$pstore.state.finaldata.length!=0">
          <div class="selediv">
            <span class="tit">{{$t('schedule.playsCount')}}</span>
            <el-select :value="countvalue1" :placeholder="$t('schedule.pleaseSelect')" size="medium" v-if="this.$pstore.state.finaldata[this.$pstore.state.currentindex].count!=0" class="select" @change="savecount" id="count">
              <el-option v-for="item in options1" :key="item.value" :label="$t(item.label)" :value="item.value">
              </el-option>
            </el-select>
            <el-input v-model="my_countvalue" @blur="save_my_countvalue" size="medium" style="width: 221px;" oninput="value=value.replace(/[^\d]/g,'')" v-if="this.$pstore.state.finaldata[this.$pstore.state.currentindex].count==0">
            </el-input>
          </div>
          <template>

          </template>
          <div class="type">
            <div class="select seletype">
              <span>{{$t('basics.inStreamType')}}:</span>
              <el-select v-model="urgency_type" :placeholder="$t('schedule.pleaseSelect')" class="selects">
                <el-option v-for="item in urgency_type_option" :key="item.value" :label="$t(item.label)" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="block" v-show="this.urgency_type==0">
              <el-date-picker v-model="urgency_time" type="datetime" :placeholder="$t('schedule.selectDate')" @change="changeData">
              </el-date-picker>
            </div>
          </div>
          <div class="button">
            <div class="control fabu" @click="publish()">{{$t('schedule.publish')}}</div>
            <!-- <div class="control white" @click="savePlanDate()">保存</div> -->
            <div class="control white" @click="cancel">{{$t('terminal.cancel')}}</div>
          </div>
        </template>
      </template>
    </enfold-uc>
    <!-- <get-device-dialog :deviceDialogVisible="deviceDialogVisible" @changeShow="showAdd"
			:play_mode="3" :urgency_time='Number(urgency_time/1000)' :urgency_type='urgency_type'>
		</get-device-dialog> -->
    <terminal-list :terminalListDV="deviceDialogVisible" @publishTerminal="publishTerminal"></terminal-list>
  </div>
</template>
<!-- 紧急插播 -->
<script>
let now_time = new Date();
//import GetDeviceDialog from "./GetDeviceDialog.vue"
import EnfoldUc from "@/components/basics/EnfoldUC";
import TerminalList from '@/components/schedule/windows/children/TerminalList';
import { groupByTerminal } from "@/assets/scripts/publicFunction.js";
export default {
  name: 'UrgencyPlan',
  components: {
    //GetDeviceDialog,
    EnfoldUc,
    TerminalList
  },
  created() {
    this.urgency_type = 1;
    this.urgency_time = new Date()
  },
  data() {
    return {
      urgency_time: '',
      urgency_type: '',
      urgency_type_option: [{
        value: 0,
        label: 'schedule.instreamResver'
      }, {
        value: 1,
        label: 'schedule.instreamNow'
      },],
      options1: [{
        value: '0',
        label: 'schedule.customize'
      },
      {
        value: '1',
        label: 'schedule.once'
      }, {
        value: '2',
        label: 'schedule.twice'
      }, {
        value: '3',
        label: 'schedule.treeTimes'
      }, {
        value: '4',
        label: 'schedule.fourTimes'
      }, {
        value: '5',
        label: 'schedule.fiveTimes'
      }, {
        value: '6',
        label: 'schedule.sixTimes'
      }, {
        value: '7',
        label: 'schedule.sevenTimes'
      }, {
        value: '8',
        label: 'schedule.eightTimes'
      }, {
        value: '9',
        label: 'schedule.nineTimes'
      }, {
        value: '10',
        label: 'schedule.tenTimes'
      }
      ],
      countvalue: this.countvalue1,
      deviceDialogVisible: false
    }
  },
  methods: {
    savecount(v) {
      this.$pstore.commit('savecount', v);
      this.$forceUpdate()
    },
    save_my_countvalue() {
      this.$pstore.commit('save_my_countvalue', this.my_countvalue);
    },
    changeData() {
      if (this.urgency_time < now_time) {
        this.$msg({
          message: this.$t('schedule.selectTimeTips'),
          type: 'warning'
        });
        this.urgency_time = now_time;
      }
    },
    publish() {
      console.log('urgency_type', this.urgency_type);
      console.log('urgency_time', typeof (this.urgency_time))
      console.log('urgency_time', Number(this.urgency_time))
      this.deviceDialogVisible = true
    },
    publishTerminal(terminalList, adapter_screen, isAppend) {
      if (terminalList && terminalList.length > 0) {


        const group_id = this.$cookies.get("group_id");
        this.$pstore.commit('publish', [terminalList, adapter_screen, isAppend, 3, group_id]);

        let listGroup = groupByTerminal(terminalList, "main_device").map((group) => {
          const { list, main_device } = group;
          return { main_device, ids: list.map((d) => d.id) };
        });

        const { group_id: p_group_id, play_ids, play_mode, publish_strategy, publish_type, isAppend: p_isAppend, adapter_screen: p_adapter_screen, playSchedule } = this.$pstore.state.publishData
        this.$http.post("/admin/publish/addNew", {
          group_id: p_group_id,
          play_ids: play_ids,
          list_group: encodeURIComponent(JSON.stringify(listGroup)),
          play_mode: play_mode,
          publish_strategy: publish_strategy,
          publish_type: publish_type,
          isAppend: p_isAppend,
          adapter_screen: p_adapter_screen,
          playSchedule: encodeURIComponent(JSON.stringify(playSchedule)),
          playCount: this.$pstore.state.publishData.playCount,
          startTime: this.urgency_type == 1 ? 0 : parseInt(Number(this.urgency_time/1000)),
          is_drafts: 0
        }, () => {
          this.$http.post("/admin/Command/getDownloadList", {}, (res) => {
            this.$store.commit("ISSUE_LIST", res);
          });
        });

        this.$msg({ message: this.$t('cscu1'), type: 'success', });
        this.$router.push({ name: 'IssueManage' });

        // let listGroup = groupByTerminal(terminalList, "main_device")
        // const group_id = this.$cookies.get("group_id");
        // this.$pstore.commit('publish', [terminalList, adapter_screen, isAppend, 3,group_id]);

        // listGroup.forEach(ele=>{
        // 	let idList = [];
        // 	ele.list.forEach(val=>{
        // 		idList.push(val.id)
        // 	})
        // 	this.$http.post("/admin/publish/add", {
        // 		group_id: this.$pstore.state.publishData.group_id,
        // 		play_ids: this.$pstore.state.publishData.play_ids,
        // 		device_ids: idList.toString(),
        // 		main_device:ele.main_device,
        // 		play_mode: this.$pstore.state.publishData.play_mode,
        // 		publish_strategy: this.$pstore.state.publishData.publish_strategy,
        // 		publish_type: 0,
        // 		isAppend: this.$pstore.state.publishData.isAppend,
        // 		adapter_screen: this.$pstore.state.publishData.adapter_screen,
        // 		playCount: this.$pstore.state.publishData.playCount,
        // 		startTime: this.urgency_type == 1 ? 0 : parseInt(Number(this.urgency_time/1000)),
        // 		is_drafts: 0
        // 	}, data => {
        // 		console.log(data)
        // 		this.$http.post("/admin/Command/getDownloadList", {}, data => {
        // 			this.$store.commit("ISSUE_LIST", data);
        // 		});
        // 		this.$msg({
        // 			message: this.$t('schedule.pubSuccessTip'),
        // 			type: 'success',
        // 		});
        // 		this.$router.push({
        // 			name: 'IssueManage'
        // 		})
        // 	})
        // })

      }
      this.deviceDialogVisible = false;
    },
    showAdd(data) {
      if (data === 'false') {
        this.deviceDialogVisible = false
      } else {
        this.deviceDialogVisible = true
      }
    },
    cancel() {
      this.$router.push({
        path: 'IssueManage'
      })
      //this.$pstore.commit('clearitems')
    }
  },
  computed: {
    my_countvalue: {
      get() {
        console.log('11111', this.$pstore.state.finaldata[this.$pstore.state.currentindex])
        return this.$pstore.state.finaldata[this.$pstore.state.currentindex].my_countvalue
      },
      set(v) {
        this.$pstore.state.finaldata[this.$pstore.state.currentindex].my_countvalue = v;
      }
    },
    countvalue1() {
      return this.$pstore.state.finaldata[this.$pstore.state.currentindex].count;
    }

  }
}
</script>

<style lang="scss" scoped>
.selediv /deep/ .el-input__inner {
  border-radius: 40px;
}

.type {
  display: flex;
  align-items: center;
  position: absolute;
  left: 20px;
  bottom: 14%;
  width: 540px;
  justify-content: space-between;
  .block {
    margin-left: 20px;
  }
  .selects {
    margin-left: 20px;
  }
}

.urgency_plan {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: white;
}

.control:hover {
  cursor: pointer;
}

.titd {
  height: 100%;
  width: 100%;
}

.titd::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.tit {
  font-family: PingFang-SC-Regular;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 3px;
  height: 16px;
  letter-spacing: 3px;
  color: #617883;
  padding-left: 2%;
}

.selediv {
  margin-top: 2%;
  margin-left: 2%;
}

#count {
  margin-left: 2%;
}

.button {
  /* margin: 0 auto;
		margin-bottom: 0; */
  position: absolute;
  left: 50%;
  bottom: 4%;
  transform: translate(-50%);
  width: 44%;
  height: 6%;
  min-width: 380px;
  min-height: 35px;
  display: flex;
  justify-content: space-between;
}

.control {
  width: 40%;
  text-align: center;
  align-items: center;
  border-radius: 40px;
}

.control::before {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.fabu {
  background-image: linear-gradient(
      270deg,
      #86eae7 0%,
      #4cccf0 45%,
      #11adf8 100%
    ),
    linear-gradient(#dddddd, #dddddd);
  background-blend-mode: normal, normal;
  border-radius: 40px;
  font-family: PingFang-SC-Regular;
  font-size: 24px;
  font-stretch: normal;
  line-height: 38px;
  letter-spacing: 0px;
  color: #ffffff;
}

.white {
  border-radius: 40px;
  border-style: solid;
  font-size: 24px;
  border-width: 1px;
  font-family: PingFang-SC-Regular;
  border-image-slice: 1;
  color: #2fb3ff;
}
.type {
  /deep/ .el-input__inner {
    border-radius: 40px;
  }
}
.seletype {
  /deep/ .el-input__inner {
    width: 160px;
    border-radius: 40px;
  }
}
</style>
